/**
 * Parse WebSocket call event data that may be a JSON string or double-encoded JSON.
 */
export function parseCallEventPayload(rawData) {
  if (rawData == null) {
    return {};
  }

  if (typeof rawData === "object") {
    return rawData;
  }

  if (typeof rawData !== "string") {
    return {};
  }

  let parsed = rawData;
  for (let i = 0; i < 3; i++) {
    if (typeof parsed !== "string") {
      break;
    }
    try {
      parsed = JSON.parse(parsed);
    } catch {
      return {};
    }
  }

  return typeof parsed === "object" && parsed !== null ? parsed : {};
}
